

import { controls } from './controls';



const showroom5 = {
  label: "showroom5",
  pageLabel: "showroom 5 ",
  starting: true,
  url: "showroom4",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "HTML Table",
        uid: "htmltable",
        style: {
          textDecoration: "underline"
        }
      },
      {
        label: "Fast Path",
        uid: "fastpathcontain",
        style: {
          textDecoration: ""
        }
      }



    ]
  },
  form: [
      {
        inputType:'fastpathContainer',
        pagename:'ms13',
        tab:"fastpathcontain",
      },
    {
        inputType: "table",
        tab:"htmltable",
        tableTitle: "Tax Summary",
        tableHeaders: [
          { label: "Branch", value: "type" ,searchable: true, control:'branch'},
          { label: "Credited", value: "credit" ,searchable: true},
          { label: "Debited", value: "debit" },
          { label: "Payable", value: "payable" },
          { label: "Receivable", value: "receivable" }
        ],
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        name: "taxSummaryTable"
      }
    
  ]
};

export default showroom5;